import { Controller } from 'stimulus';

const FIELD_ERROR_CLASS = 'field--error';

export default class extends Controller {
  static targets = ['error', 'indicator'];

  #onEdit;

  connect() {
    this.#onEdit = (event) => this.#edited(event);
    this.element.addEventListener('input', this.#onEdit);
    this.element.addEventListener('change', this.#onEdit);
    this.#syncIndicator();
  }

  disconnect() {
    this.element.removeEventListener('input', this.#onEdit);
    this.element.removeEventListener('change', this.#onEdit);
  }

  #edited(event) {
    event.target?.classList?.remove(FIELD_ERROR_CLASS);
    if (!this.#showing) {
      return;
    }
    this.errorTarget.classList.add('hidden');
    this.#syncIndicator();
  }

  get #showing() {
    return this.hasErrorTarget && !this.errorTarget.classList.contains('hidden');
  }

  #syncIndicator() {
    if (this.hasIndicatorTarget) {
      this.indicatorTarget.style.display = this.#showing ? 'none' : '';
    }
  }
}
